import React from 'react';
import PropTypes from 'prop-types';
import MarkdownText from '../../../components/foundations/MarkdownText';
import css from './MarkdownArtifact.css';

const MarkdownArtifact = ({ artifact }) => {
    const content = artifact.data;

    return (
        <div className={css.content}>
            {typeof content === 'string' ? (
                <MarkdownText content={content} />
            ) : (
                <>
                    <div className={css.errorText}>Invalid markdown format</div>
                    <pre className={css.errorData}>{JSON.stringify(artifact.data, null, 2)}</pre>
                </>
            )}
        </div>
    );
};

MarkdownArtifact.propTypes = {
    artifact: PropTypes.shape({
        data: PropTypes.string,
    }).isRequired,
};

export default MarkdownArtifact;
